module.exports = __webpack_public_path__ + "images/emoji/sunrise.9068830120e82642538a.png";